import { Link } from 'react-router-dom';
import { BRAND_NAME, BrandLockup } from './branding';
import './AppFooter.css';

/**
 * Shared bottom chrome. Lighter than the header — doesn't repeat the
 * navigation, just establishes "you're on BytaApps" with a small
 * mark + the policy / contact links a kid (or grown-up) might need.
 */
export function AppFooter(): JSX.Element {
  return (
    <footer className="bl-appfooter">
      <div className="bl-appfooter__inner">
        <BrandLockup size="sm" />
        <nav className="bl-appfooter__nav" aria-label="Footer">
          <Link to="/about">About</Link>
          <Link to="/gallery">Gallery</Link>
          <Link to="/privacy">Privacy</Link>
          <Link to="/contact">Contact</Link>
        </nav>
        <p className="bl-appfooter__legal">
          © {new Date().getFullYear()} {BRAND_NAME}. Train in your browser. Your stuff stays on your
          device unless you choose to share it.
        </p>
      </div>
    </footer>
  );
}
